// extracted by mini-css-extract-plugin
export var close = "modal-module--close--b3b96";
export var modal = "modal-module--modal--36f29";
export var modal_body = "modal-module--modal_body--4b88f";
export var sizing_tableWr = "modal-module--sizing_table-wr--f7d46";
export var title = "modal-module--title--c5cb5";